<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import UserProfileBubble from "@kontextwerk/web-sdk/ui/display/UserProfileBubble.svelte"
  import type { ColumnDef } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
  import { USER_ACCOUNT_STATUS_DEFINITIONS, type UserRow } from "../../_shared/_logic/table"

  interface Props {
    row: UserRow
    column: ColumnDef
  }

  let { row, column }: Props = $props()

  const roleStatus = $derived({ value: row.roleId ?? "unknown", label: row.roleLabel })
</script>

{#if column.id === "statusLabel"}
  {#if row.statusKey}
    <span class="status-cell-tag">
      <StatusTag size="sm" status={USER_ACCOUNT_STATUS_DEFINITIONS[row.statusKey]} />
    </span>
  {:else}
    <span class="missing">{row.statusLabel}</span>
  {/if}
{:else if column.id === "profile"}
  <span class="profile-cell">
    <UserProfileBubble user={row.profile} size={34} emphasized={true} />
  </span>
{:else if column.id === "roleLabel"}
  {#if row.roleId && row.roleLabel !== "—"}
    <span class="status-cell-tag">
      <StatusTag variant="neutral" size="sm" status={roleStatus} />
    </span>
  {:else}
    <span class="missing">{row.roleLabel}</span>
  {/if}
{:else if column.id === "email"}
  {row.email || "—"}
{:else}
  {row.name}
{/if}

<style lang="less">
  .status-cell-tag {
    display: inline-flex;
    align-items: center;
  }

  .profile-cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .missing {
    color: color-mix(in srgb, var(--text-invers-100) 70%, transparent);
  }
</style>
